"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var Logging_1 = require("../Logging");
var Types_1 = require("../Types");
var EventProperties_1 = require("../EventProperties");
var SchemaBuilder = (function () {
    function SchemaBuilder() {
    }
    SchemaBuilder.ForComponent = function (commonProperties, eventProperties, data, approvedEvent) {
        var event = {
            data: __assign({ _meta: {
                    GtlGroupIdType: eventProperties.groupIdType,
                    GtlPrivacyTag: eventProperties.privacyTags,
                    GtlEventKeyword: approvedEvent ? eventProperties.keyword : 0
                }, extendedData: commonProperties.extendedData }, data),
            ext: {
                mscv: {
                    cV: EventProperties_1.ComponentEventProperties.CorrelationVector
                }
            },
            name: "Microsoft.Gaming." + EventProperties_1.ComponentEventProperties.ComponentName + "." + eventProperties.eventName,
            persistence: eventProperties.persistence,
            latency: eventProperties.latency
        };
        if (eventProperties.DIV) {
            if (EventProperties_1.ClickstreamEventProperties.PreserveExistingCorrelationVector) {
                event.data.GtlDeviceInteractionVector = eventProperties.DIV;
            }
            else {
                if (event.ext.mscv.cV) {
                    event.data.relatedCv = event.ext.mscv.cV;
                }
                event.ext.mscv.cV = eventProperties.DIV;
            }
        }
        return event;
    };
    SchemaBuilder.ForComponentWithBase = function (commonProperties, eventProperties, data, baseType, baseData, approvedEvent) {
        return __assign({ baseType: baseType,
            baseData: baseData }, this.ForComponent(commonProperties, eventProperties, data, approvedEvent));
    };
    SchemaBuilder.ForOptionalCritical = function (commonProperties, eventProperties, data, approvedEvent) {
        return this.forCritical(commonProperties, eventProperties, data, false, approvedEvent);
    };
    SchemaBuilder.ForRequiredCritical = function (commonProperties, eventProperties, data) {
        return this.forCritical(commonProperties, eventProperties, data);
    };
    SchemaBuilder.forCritical = function (commonProperties, eventProperties, data, isRequired, hasApproval) {
        if (isRequired === void 0) { isRequired = true; }
        Logging_1.console_assert(eventProperties.eventName !== "", "GamingTelemetry: No event name provided for critical telemetry.");
        var GtlIsRequired = isRequired;
        var GtlPrivacyTag;
        var GtlEventKeyword;
        if (GtlIsRequired) {
            Logging_1.console_assert(hasApproval === undefined, "GamingTelemetry: Approval is not necessary for Required data.");
            GtlPrivacyTag = Types_1.PrivacyTag.ProductAndServicePerformance;
            GtlEventKeyword = Types_1.EventKeyword.Critical;
        }
        else {
            GtlPrivacyTag = Types_1.PrivacyTag.ProductAndServiceUsage;
            GtlEventKeyword = hasApproval ? Types_1.EventKeyword.Critical : 0;
        }
        var event = {
            data: __assign({ _meta: {
                    GtlIsRequired: GtlIsRequired,
                    GtlPrivacyTag: GtlPrivacyTag,
                    GtlEventKeyword: GtlEventKeyword
                }, extendedData: commonProperties.extendedData, componentName: EventProperties_1.ComponentEventProperties.ComponentName }, data),
            ext: {
                mscv: {
                    cV: EventProperties_1.ComponentEventProperties.CorrelationVector
                }
            },
            name: "Microsoft.Gaming.Critical." + eventProperties.eventName,
            persistence: 2
        };
        return event;
    };
    return SchemaBuilder;
}());
exports.SchemaBuilder = SchemaBuilder;
//# sourceMappingURL=SchemaBuilder.js.map